$(function() {
    const background = $('<div class="sub-menu__hover"></div>');
    $('.main__navigation .sub-menu').append(background);

    $('.main__navigation .sub-menu .menu-item a').on('mouseenter', (e)=>{
        const top = $(e.currentTarget).closest('.menu-item').position().top;
        background.css('top', top);

    })
});